import styles from './Checkout.scss';

import React from 'react';
import {
  Route,
  RouteComponentProps,
  Switch
} from 'react-router-dom';

import { CheckoutBasePage } from './CheckoutBasePage/CheckoutBasePage';
import { CheckoutEmailPage } from './CheckoutEmailPage/CheckoutEmailPage';
import { CheckoutInfoPage } from './CheckoutInfoPage/CheckoutInfoPage';
import { CheckoutProvider } from './CheckoutProvider';
import { CheckoutReviewPage } from './CheckoutReviewPage/CheckoutReviewPage';
import { CheckoutStatusPage } from './CheckoutStatusPage/CheckoutStatusPage';

export enum CheckoutRoutePath {
  INFO = '/info',
  REVIEW = '/review',
  EMAIL = '/email',
  STATUS = '/status',
}

interface CheckoutProps extends RouteComponentProps<{}> {}

export const Checkout: React.FC<CheckoutProps> = ({ match }) => {
  const infoPath = `${match.url}${CheckoutRoutePath.INFO}`;
  const reviewPath = `${match.url}${CheckoutRoutePath.REVIEW}`;
  const emailPath = `${match.url}${CheckoutRoutePath.EMAIL}`;
  const statusPath = `${match.url}${CheckoutRoutePath.STATUS}`;

  return (
    <section className={styles.checkoutWrapper}>
      <CheckoutProvider>
        <CheckoutBasePage>
          <Switch>
            <Route exact path={infoPath}>
              <CheckoutInfoPage />
            </Route>
            <Route exact path={reviewPath}>
              <CheckoutReviewPage />
            </Route>
            <Route exact path={emailPath}>
              <CheckoutEmailPage />
            </Route>
            <Route exact path={statusPath}>
              <CheckoutStatusPage />
            </Route>
          </Switch>
        </CheckoutBasePage>
      </CheckoutProvider>
    </section>
  );
};

Checkout.displayName = 'Checkout';
